export default "__VITE_ASSET__EbFi9U2C__"